import React from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router";
import format from "date-fns/format";

import {
  handlePCPRequests,
  updateNotificationsStatus,
  deletePatientPCPDoctor,
} from "../../../store/actions/notificationsActions";
import * as actions from "../../../store/actions";
import {
  DEFAULT_PIC,
  getDashboardPath,
  getOnboardingPath,
} from "../../../constants";
import constants from "../../../constants";

import Modals from "../../../components/uiElements/popupModal/modal";
import AppointmentModal from "./AppointmentModal";
import {
  parseDateToLocal,
  parseTimeToLocal,
  getMeridiem,
  convertTimeTo12HourFormat,
} from "../../../utils/parseDateTime";

const NotificationList = props => {
  let dispatch = useDispatch();

  const [isOpen, setIsOpen] = React.useState();

  const notificationTypes = [
    constants.NOTIFICATION_TYPES.bookAppointment,
    constants.NOTIFICATION_TYPES.cancelledAppointment,
    constants.NOTIFICATION_TYPES.acceptAppointment,
    constants.NOTIFICATION_TYPES.deniedAppointment,
    constants.NOTIFICATION_TYPES.visitNow,
    constants.NOTIFICATION_TYPES.bookAppointment,
    constants.NOTIFICATION_TYPES.nudgePermission,
    constants.NOTIFICATION_TYPES.chatNotification,
    constants.NOTIFICATION_TYPES.callStarted,
    constants.NOTIFICATION_TYPES.appointmentCharges,
    constants.NOTIFICATION_TYPES.noShowFees,
    constants.NOTIFICATION_TYPES.loogedin_otherdevice,
    constants.NOTIFICATION_TYPES.autoCancelled
  ];

  const subscriptionNotificationTypes = [
    constants.NOTIFICATION_TYPES.subscriptionExpiring,
    constants.NOTIFICATION_TYPES.subscriptionPaymentAuth,
    constants.NOTIFICATION_TYPES.trailEnd,
  ];

  let { notification } = props;
  

  let PCPRequest = (id, status) => {
    if (status === "DECLINED") {
      dispatch(deletePatientPCPDoctor(id, notification?.id));
    }
    if (status === "APPROVED") {
      dispatch(handlePCPRequests(id, status, notification?.id));
    }
  };

  let viewDetails = (value, type) => {
    type === "pcp" && openModal(type);
    if (value?.status === "UR") {
      dispatch(updateNotificationsStatus(value?.id, "R"));
    }
  };

  let onUpdateAppointment = (status, cb) => {
    closeModal();
    dispatch(
      actions.updateAppointmentStatus(
        notification?.params?.appointment_id,
        status,
        () => {}
      )
    );
  };

  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };

  let appointmentMessage = "";
  let appointmentDate = "";
  let appointmentTime = "";

  // eslint-disable-next-line
  notificationTypes.includes(notification?.notification_type) &&
    ((appointmentDate = format(
      parseDateToLocal(notification?.params?.appointment_date),
      "MMM dd, yyyy"
    )),
    (appointmentTime = parseTimeToLocal(
      notification?.params?.appointment_time,
      notification?.params?.appointment_date
    )),
    (appointmentMessage = notification?.message
      .replace("%s", appointmentDate)
      .replace("%s", `${convertTimeTo12HourFormat(appointmentTime)}`)));

  return (
    <React.Fragment>
      {/*---- Modal ------*/}
      {isOpen === "pcp" && (
        <Modals
          isOpen={!!isOpen}
          onRequestClose={() => closeModal}
          title="PCP Request"
          btnDark={{
            label: "Accept",
            onclick: () => {
              PCPRequest(`${notification?.params?.pcp_request_id}`, "APPROVED");
              closeModal();
            },
          }}
          btnOutline={{
            label: "Deny",
            onclick: () => {
              PCPRequest(`${notification?.params?.pcp_request_id}`, "DECLINED");
              closeModal();
            },
          }}
        >
          <React.Fragment>
            <button
              onClick={closeModal}
              className="close modalCloseBtn"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="mx-auto text-center denyAppointmentText">
              Hi {props.physician}, You got a request from{" "}
              {notification?.message?.split(" ")[0]}{" "}
              {notification?.message?.split(" ")[1]} to choose you as My Doctor.
            </p>
          </React.Fragment>
        </Modals>
      )}

      {isOpen === "appointment" && (
        <AppointmentModal
          isOpen={!!isOpen}
          closeModal={closeModal}
          appointmentId={notification?.params?.id}
          message={notification?.message}
          onUpdateAppointment={onUpdateAppointment}
        />
      )}

      {/*------- Notification -------*/}
      {notification?.notification_type === "PCP_REQUEST" && (
        <div
          className="d-flex align-items-center py-3 px-4 "
          id={notification?.id}
          style={
            notification?.status === "UR"
              ? {
                  backgroundColor: "var(--profile-card-color)",
                  marginTop: "14px",
                }
              : { backgroundColor: "white", marginTop: "14px" }
          }
        >
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={notification?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={notification?.id}
            />
          </div>
          <p
            className="mb-0 notificationListFont ml-3"
            style={{ maxWidth: "78%" }}
          >
            <span style={{ fontWeight: "400" }}>{notification?.message}</span>
          </p>
          <p
            className="mb-0 underlineLink ml-auto"
            onClick={() => viewDetails(notification, "pcp")}
            style={{ cursor: "pointer" }}
          >
            View Details
          </p>
        </div>
      )}

      {notificationTypes.includes(notification?.notification_type) && (
        <div
          className="d-flex align-items-center py-3 px-4 "
          id={notification?.id}
          style={
            notification?.status === "UR"
              ? {
                  backgroundColor: "var(--profile-card-color)",
                  marginTop: "14px",
                }
              : { backgroundColor: "white", marginTop: "14px" }
          }
        >
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={notification?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={notification?.id}
            />
          </div>
          <p
            className="mb-0 notificationListFont ml-3"
            style={{ maxWidth: "78%" }}
          >
            <span style={{ fontWeight: "400" }}>{appointmentMessage}</span>
          </p>

          {notification?.notification_type !== "CHAT_NOTIFICATION" &&
            notification?.notification_type !== "CALL_STARTED" &&
            notification?.notification_type !== "APPOINTMENT_CHARGE" &&
            notification?.notification_type !== "NO_SHOW_FEES" && (
              <p
                className="mb-0 underlineLink ml-auto"
                onClick={() => {
                  viewDetails(notification, "appointment");
                  props.history.push(
                    getDashboardPath(
                      [
                        constants.NOTIFICATION_TYPES.visitNow,
                        constants.NOTIFICATION_TYPES.nudgePermission,
                      ].includes(notification?.notification_type)
                        ? "/appointments"
                        : `/appointments/detail/${notification?.params?.appointment_id}`
                    )
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                View Details
              </p>
            )}
        </div>
      )}

      {subscriptionNotificationTypes.includes(
        notification?.notification_type
      ) && (
        <div
          className="d-flex align-items-center py-3 px-4 "
          id={notification?.id}
          style={
            notification?.status === "UR"
              ? {
                  backgroundColor: "var(--profile-card-color)",
                  marginTop: "14px",
                }
              : { backgroundColor: "white", marginTop: "14px" }
          }
        >
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={notification?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={notification?.id}
            />
          </div>
          <p
            className="mb-0 notificationListFont ml-3"
            style={{ maxWidth: "78%" }}
          >
            <span style={{ fontWeight: "400" }}>{notification?.message}</span>
          </p>
          {notification?.notification_type !== "CHAT_NOTIFICATION" &&
            notification?.notification_type !== "CALL_STARTED" &&
            notification?.notification_type !== "APPOINTMENT_CHARGE" &&
            notification?.notification_type !== "NO_SHOW_FEES" && (
              <p
                className="mb-0 underlineLink ml-auto"
                onClick={() => {
                  viewDetails(notification, "appointment");
                  props.history.push(getOnboardingPath("/step6"));
                }}
                style={{ cursor: "pointer" }}
              >
                View Details
              </p>
            )}
        </div>
      )}

      {notification?.notification_type === "DOSESPOT_PRESCRIPTION" && (
        <div
          className="d-flex align-items-center py-3 px-4 "
          id={notification?.id}
          style={
            notification?.status === "UR"
              ? {
                  backgroundColor: "var(--profile-card-color)",
                  marginTop: "14px",
                }
              : { backgroundColor: "white", marginTop: "14px" }
          }
        >
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={notification?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={notification?.id}
            />
          </div>
          <p
            className="mb-0 notificationListFont ml-3"
            style={{ maxWidth: "78%" }}
          >
            <span style={{ fontWeight: "400" }}>{notification?.message}</span>
          </p>
        </div>
      )}
      {notification?.notification_type === "NEW_SUBSCRIPTION_REQUEST" && (
        <div
          className="d-flex align-items-center py-3 px-4 "
          id={notification?.id}
          style={
            notification?.status === "UR"
              ? {
                  backgroundColor: "var(--profile-card-color)",
                  marginTop: "14px",
                }
              : { backgroundColor: "white", marginTop: "14px" }
          }
        >
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={notification?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={notification?.id}
            />
          </div>
          <p
            className="mb-0 notificationListFont ml-3"
            style={{ maxWidth: "78%" }}
          >
            <span style={{ fontWeight: "400" }}>{notification?.message}</span>
          </p>
        </div>
      )}
    </React.Fragment>
  );
};
export default withRouter(NotificationList);
